import request from "@/utils/request";
import qs from "qs";

export function login(data) {
  return request({
    url: "/api/auth/login/",
    method: "post",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    data: qs.stringify(data),
  });
}

export function refreshToken(refresh_token) {
  return request({
    url: "/api/auth/refresh/",
    method: "post",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    data: qs.stringify({
      grant_type: "refresh_token",
      refresh_token,
    }),
  });
}

export function logout() {
  return request({
    url: "/api/auth/logout/",
    method: "post",
  });
}
